module.exports = {
  test: {
    baseURL: "http://localhost:3005",
  },
  development: {
    baseURL: "http://localhost:3005",
  },
  stage: {
    baseURL: "https://d2r8xewwiwndk4.cloudfront.net",
  },
  production: {
    baseURL: "https://d3bc3zjie580an.cloudfront.net",
  },
}[process.env.NODE_ENV || "production"];
